// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'
import Scrollchor from 'react-scrollchor'

import { Dashboard } from '../../components/dashboard'
import ArticlePromotionBox from 'components/articlePromotionBox'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const urlCustomer = parseHostname().publicationDomain

const ARTICLE_ID = '31873476'
const ADDITIONAL_SHARES = 430

class AppComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              So stark verändert sich der Nationalrat im Herbst
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Das konservative Lager könnte über ein Dutzend Sitze verlieren.
                Die Folge sind neue Mehrheiten in der Gesellschaftspolitik.
                Unsere Prognose für jede Partei in allen 26 Kantonen.
              </div>
            </h2>
            <p className='ta author'>
              <strong>
                Raphaela Birrer, Markus Häfliger und Patrick Vögeli
              </strong>
            </p>
          </div>
        </header>

        <p className='spaced'>&nbsp;</p>

        <div className='ui container'>
          <div className='ui tight grid'>
            <div className='doubling four column row'>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_svp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_sp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_fdp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_cvp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_gruene.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_glp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
              <div className='column tight'>
                <img
                  src={require('./imgs/waehleranteil_bdp.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </div>
            </div>
          </div>
          <p className='text source'>
            Hinweis: Tamedia-Umfrage vom September 2019 (max. Fehlerbereich +/-
            1,3%-Punkte), SRG-Umfrage vom Oktober 2019 (max. Fehlerbereich +/-
            1,4%-Punkte) <br />
            Grafik: pvo/Quelle: BFS, SRG, Tamedia
          </p>
        </div>

        {/* TODO And probably remove the following segment and replace it with
       your own content */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <p>
              Grüne und GLP gewinnen, SVP, CVP und BDP verlieren, SP und FDP
              stagnieren: Mit dieser Formel wird sich die Zusammensetzung des
              Nationalrats gemäss Prognose dieser Zeitung am 20. Oktober markant
              verändern. Mit den neuen Kräfteverhältnissen dürfte die grosse
              Kammer nicht nur ökologischer und linker, sondern auch
              progressiver werden. Dass das konservative Lager, zu dem neben der
              SVP auch die rechten Flügel der Mitte-Parteien CVP und BDP
              gehören, geschwächt wird, könnte sich insbesondere
              gesellschaftspolitisch auswirken. Seit Jahren blockierte Vorlagen
              wie individualisierte Steuermodelle, Ehe für alle, Elternzeit oder
              Cannabis-Versuche in den Städten wären in der neuen Konstellation
              im Nationalrat eher mehrheitsfähig – zumal auch die liberale FDP
              viele solcher Anliegen mitträgt. Schwerer dürften es hingegen
              wirtschaftsliberale Ansätze haben: Die erstarkten grünen Kräfte
              und die auf hohem Niveau stabile SP wollen gerade im aktuell
              dominierenden Klima- und Umweltschutz die Wirtschaft stärker in
              die Pflicht nehmen.
            </p>
            <p>
              Der Formstand der politischen Lager und die inhaltlichen Folgen
              ergeben sich aus einer grossen Analyse über die potenziellen
              Sitzverschiebungen bei den Wahlen im Herbst. Zu diesem Zweck hat
              diese Zeitung die Ausgangslage für die Parteien in allen 26
              Kantonen untersucht. Die Auswertung basiert auf den Wähleranteilen
              bei den letzten kantonalen und nationalen Wahlen, stützt sich auf
              die verfügbaren Wahlumfragen, berücksichtigt die
              Listenverbindungen und kantonale Besonderheiten wie
              lagerübergreifende Allianzen. (
              <Scrollchor to='methodik' className='nav-link'>
                siehe Methodik
              </Scrollchor>
              )
            </p>
            <h4>Das sind die Hauptbefunde</h4>

            <div className='ui bulleted list'>
              <div className='item' style={{ lineHeight: '1.44em' }}>
                <i className='' />
                <div
                  className='content'
                  style={{ lineHeight: '1.44em', paddingBottom: '1em' }}
                >
                  <div className='header'>
                    Grüne und GLP: Die ökologischen Kräfte gewinnen{' '}
                    <i className='arrow icon up' />
                  </div>
                  <div className='listDescription'>
                    <p>
                      Die Ausgangslage für Grüne und GLP ist angesichts der
                      Themenkonjunktur komfortabel: Sie dürften die grossen
                      Wahlsiegerinnen sein. Die Grünen (heute 11 Sitze) haben
                      ein Gewinnpotenzial von bis zu 9 Sitzen. In vier Kantonen
                      stehen die Chancen sehr gut, während nur einer der
                      bestehenden Sitze gefährlich wackelt. Intakte Chancen
                      haben die Grünen in sechs weiteren Kantonen – darunter in
                      mehreren, in denen sie bei den letzten Wahlen Mandate
                      verloren hatten. Besonders in Form ist die Partei in der
                      Romandie und in der Ostschweiz.
                    </p>
                    <p>
                      Die GLP dürfte alle acht bestehenden Sitze halten. In
                      Zürich und Luzern hat sie besonders hohe Chancen für einen
                      Sitzgewinn – in Zürich könnte es sogar für zwei Mandate
                      reichen. In vier weiteren Kantonen sind die Chancen
                      intakt. Häufig stehen die Grünliberalen dabei in direkter
                      Konkurrenz zu den Grünen und der SP. Die drei Parteien
                      schmälern ihre Gewinnchancen wechselseitig – was ihr
                      Potenzial einschränkt. Auch das hohe Quorum in kleinen
                      Kantonen macht es der Kleinpartei GLP vergleichsweise
                      schwer, Mandate zu gewinnen.
                    </p>
                  </div>
                </div>
              </div>
              <div className='item' style={{ lineHeight: '1.44em' }}>
                <div
                  className='content'
                  style={{ lineHeight: '1.44em', paddingBottom: '1em' }}
                >
                  <div className='header'>
                    SVP: Der rechte Pol verliert{' '}
                    <i className='arrow down icon' />
                  </div>
                  <div className='listDescription'>
                    Das grösste Netto-Verlustpotenzial hat mit bis zu neun
                    Sitzen die SVP. In vier Kantonen ist das Risiko für die
                    Partei gross, in sechs weiteren moderat. Aussicht auf einen
                    Sitzgewinn hat die SVP nur in einem Kanton (OW) – und auch
                    dort nur verbunden mit den Unwägbarkeiten einer Majorzwahl.
                    Bei den Wahlen 2015 hatte die Partei um 11 auf 64 Sitze
                    zugelegt – nun dürfte sie einen grossen Teil dieses
                    Zuwachses wieder verlieren. Trotzdem wird die SVP die mit
                    Abstand stärkste Fraktion im Bundeshaus bleiben.
                  </div>
                </div>
              </div>
              <div className='item' style={{ lineHeight: '1.44em' }}>
                <div
                  className='content'
                  style={{ lineHeight: '1.44em', paddingBottom: '1em' }}
                >
                  <div className='header'>
                    CVP und BDP: Die Mitte verliert{' '}
                    <i className='arrow down icon' />
                  </div>
                  <div className='listDescription'>
                    <p>
                      Für die BDP werden die Wahlen existenzbedrohend: Von ihren
                      sieben Sitzen wird sie jene in Graubünden und Zürich mit
                      hoher Wahrscheinlichkeit verlieren, zwei weitere im Aargau
                      und in Bern wackeln. Neben der – mutmasslich verkleinerten
                      – Berner Deputation sitzt nur Parteichef Martin Landolt in
                      Glarus fest im Sattel. Damit würde die Partei im
                      Bundeshaus unter die für die Fraktionsbildung nötige
                      Mindestzahl von fünf Sitzen schrumpfen.
                    </p>
                    <p>
                      Auch die CVP droht bis zu einem Viertel ihrer heute 26
                      Mandate zu verlieren. Je einen Sitz im Wallis und in
                      Luzern wird sie mit hoher Wahrscheinlichkeit einbüssen,
                      bei vier weiteren besteht ein erhöhtes Risiko. In drei
                      Kantonen hat sie moderate Chancen, einen Sitz zu gewinnen.
                      In der Summe dürfte die CVP somit zwischen drei und sechs
                      Mandate weniger haben. Dass die Bilanz nicht schlechter
                      ausfällt, hat sie vielerorts breiten
                      Mitte-Listenverbindungen zu verdanken.
                    </p>
                  </div>
                </div>
              </div>
              <div className='item' style={{ lineHeight: '1.44em' }}>
                <div
                  className='content'
                  style={{ lineHeight: '1.44em', paddingBottom: '1em' }}
                >
                  <div className='header'>
                    SP und FDP: Die beiden Bundesratsparteien stagnieren{' '}
                    <i className='arrow right icon' />
                  </div>
                  <div className='listDescription'>
                    <p>
                      Die SP, die heute 42 Sitze hat, steht insbesondere in der
                      Romandie unter Druck: Ohnehin bedrängt von der extremen
                      Linken, machen ihr dort die aufstrebenden Grünen
                      Konkurrenz. Ihre Herausforderung ist es daher, die
                      bestehenden Sitze zu halten. Schweizweit sind in der Summe
                      vier Sitzgewinne möglich, während die SP drei Mandate zu
                      verlieren droht. Unter dem Strich könnte die Partei somit
                      um einen Sitz zulegen.
                    </p>
                    <p>
                      Auch die Sitzzahl der FDP – heute 33 – dürfte vielerorts
                      stabil bleiben. Zwei Mandate sind moderat, jenes in Zug
                      stark gefährdet. In fünf Kantonen hat die FDP Aussicht auf
                      einen Sitzgewinn, jenen in Graubünden wird sie mit hoher
                      Wahrscheinlichkeit holen. In der Summe dürfte die Partei
                      mit zwei möglichen Sitzgewinnen stabil bleiben. Damit wäre
                      die FDP die einzige Partei rechts der Mitte, die sich
                      mindestens halten kann.
                    </p>
                  </div>
                </div>
              </div>

              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === Waypoint.below) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'Interactions',
                      event_action: 'vertical-scroll',
                      event_label: '20ContentRead'
                    })
                  }
                }}
              />
            </div>
          </div>

          <Dashboard />
        </div>

        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Text, Recherche und Analyse',
              'Raphaela Birrer und Markus Häfliger'
            ],
            ['Digitale Umsetzung und Infografiken', 'Patrick Vögeli']
          ]}
        >
          <ArticlePromotionBox
            url={`https://interaktiv.${urlCustomer}/2019/prognose-staenderatswahlen/?nosome`}
            img={require('./imgs/teaser_staenderatswahlen.jpg')}
            linktext='So stark verändert sich der Ständerat im Herbst: Unsere Prognose für jede Partei in allen 26 Kantonen.'
          />

          <div className='ui vertical fitted attached segment' id='methodik'>
            <div
              className='ui text container methodik'
              style={{ position: 'relative' }}
            >
              <div className='innerWrapperMethodik'>
                <h3 className='methodik'>Methodik</h3>
              </div>

              <p>
                Diese Prognose für die Nationalratswahlen 2019 wurde in vier
                Schritten erstellt:
              </p>
              <ol className='listMethodik'>
                <li>
                  Die Ergebnisse der eidgenössischen Wahlen 2015 wurden für
                  jeden Kanton und jede Partei einzeln analysiert. So wurden
                  jene Nationalratssitze identifiziert, die eine Partei damals
                  knapp gewonnen oder knapp verpasst hat.
                </li>
                <li>
                  Gestützt auf die verfügbaren Wahlumfragen (SRG-Wahlbarometer,
                  Tamedia-Wahlumfrage, kantonale Umfragen) sowie die letzten
                  kantonalen Wahlen, wurde in jedem Kanton für jede Partei die
                  Entwicklung bei der Parteistärke grob prognostiziert.
                </li>
                <li>
                  Gestützt auf die Schritte 1 und 2, wurden in jedem Kanton jene
                  Parteien identifiziert, welche Wackelsitze oder das Potenzial
                  für Sitzgewinne haben. Dabei wurden die Listenverbindungen
                  berücksichtigt, welche auf die Sitzverteilung einen grossen
                  Einfluss haben können.
                </li>
                <li>
                  Im letzten Schritt wurde für jede Partei ein Trend formuliert:
                  <ul>
                    <li>
                      Grosse Chancen auf Sitzgewinn{' '}
                      <i className='arrow up icon small' />
                    </li>
                    <li>
                      Chancen auf Sitzgewinn{' '}
                      <i className='arrow up icon half small' />
                    </li>
                    <li>
                      Voraussichtlich stabil{' '}
                      <i className='arrow right icon small' />
                    </li>
                    <li>
                      Risiko für Sitzverlust{' '}
                      <i className='arrow down icon half small' />
                    </li>
                    <li>
                      Grosses Risiko für Sitzverlust{' '}
                      <i className='arrow down icon small' />
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
          </div>
        </Footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
